import './App.css';
import Sidebar from "../Sidebar";
import Main from "../Main";
import React, {useEffect, useState} from "react";

function App() {
    const [notes, setNotes] = useState( localStorage.notes ? JSON.parse(localStorage.notes) : []);
    const [activeNote, setActiveNote] = useState(null);

    useEffect(()=>{
        localStorage.setItem("notes", JSON.stringify(notes))
    }, [notes])

    const addNoteHandler = ()=>{
        let newNote = {
            id : Date.now(),
            title: "Untitled Note",
            body: "",
            lastModified: Date.now()
        }
        setNotes([...notes, newNote])
    }

    const  deleteNoteHandler = (noteId)=>{
        setNotes(notes.filter(note=>note.id !==noteId))
    }

    const getActiveNote = ()=>{
        return notes.find(note=>note.id===activeNote)
    }

    const updateNote = (updatedNote)=>{
        let updatedNotesSet = notes.map(note=>{
            if (note.id===activeNote){
                return updatedNote
            }
            return note;
        })
        setNotes(updatedNotesSet)
    }

  return (
    <div className="App">
      <Sidebar
          notes={notes}
          deleteNote={deleteNoteHandler}
          addNote={addNoteHandler}
          activeNote={activeNote}
          setActiveNote={setActiveNote}
      />
      <Main activeNote={getActiveNote()} updateNote={updateNote}/>
    </div>
  );
}

export default App;
